import { render, staticRenderFns } from "./ClinicsTable.vue?vue&type=template&id=1d3d94c6&"
import script from "./ClinicsTable.vue?vue&type=script&lang=js&"
export * from "./ClinicsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClinicsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports